import { useClerk } from '@clerk/clerk-react'
import { useNavigate } from 'react-router-dom'
import { hasAnyFeatureAccess } from '../../utility/noPermissionEmptyState'
import { clearLocalStorage } from '../../utility/utility'
import Button from '../Button/Button'
import NoDataFound from '../NoDataFound/NoDataFound'

const FEATURE_NOT_ENABLED_TITLE = (
  <div className="mb-6">
    This feature is not enabled for your account. <br />
    Contact your system administrator to add you to the relevant user access group to access the
    feature.
  </div>
)

const NoPermissionEmptyState = ({
  uagEnhancements,
  featurePermissions,
  userFeaturePermissions,
  onGoBack,
  onSignOut,
  wrapperTestId,
  containerTestId = 'no-permission-empty-state',
  noDataFoundTestId = 'no-permission-no-data-found',
}) => {
  const navigate = useNavigate()
  const clerk = useClerk()

  const handleGoBack = onGoBack ?? (() => navigate('/'))

  const handleSignOut =
    onSignOut ??
    (async () => {
      const sessionId = clerk?.session?.id
      try {
        clearLocalStorage()
        await clerk.signOut({ sessionId })
        window.location.href = '/login'
      } catch (error) {
        console.error('Error signing out:', error)
      }
    })

  const showGoBack = hasAnyFeatureAccess({
    uagEnhancements,
    featurePermissions,
    userFeaturePermissions,
  })

  return (
    <div
      className="w-full h-full flex items-center justify-center bg-BG-Default-neutral-00 z-[999999]"
      {...(wrapperTestId ? { 'data-testid': wrapperTestId } : {})}
    >
      <div
        className="flex flex-1 flex-col justify-center items-center"
        data-testid={containerTestId}
      >
        <NoDataFound
          title={FEATURE_NOT_ENABLED_TITLE}
          subtitle={
            showGoBack ? (
              <Button
                type="primary"
                className="text-base w-fit py-2 px-4"
                onClick={handleGoBack}
                text="Go back"
              />
            ) : (
              <Button
                type="primary"
                className="text-base w-fit py-2 px-4"
                onClick={handleSignOut}
                text="Log out"
              />
            )
          }
          data-testid={noDataFoundTestId}
        />
      </div>
    </div>
  )
}

export default NoPermissionEmptyState
